export const PWA_INSTALLED_KEY = 'pwa-installed-at';

export function hasInstalledMarker(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(PWA_INSTALLED_KEY) !== null;
}

export function markInstalled(now = Date.now()): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(PWA_INSTALLED_KEY, String(now));
}
